import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, delay, ease: [0.2, 0.8, 0.2, 1] }}
  >
    {children}
  </motion.div>
);

export const Marquee = ({ items, dark }) => (
  <div className={`marquee py-5 border-y ${dark ? "border-white/15" : "border-[var(--line)]"}`}>
    <div className="marquee__track">
      {[0, 1].map((k) => (
        <span key={k} aria-hidden={k === 1}>
          {items.map((it, i) => (
            <span key={i} className="sash-serif italic text-[clamp(1.4rem,3.2vw,2.6rem)] px-6 whitespace-nowrap">
              {it}
              <span className="not-italic mx-6" style={{ color: "var(--tan)" }}>✦</span>
            </span>
          ))}
        </span>
      ))}
    </div>
  </div>
);

export const MaskedHeadline = ({ lines, className }) => (
  <h1 className={className}>
    {lines.map((ln, i) => (
      <span key={i} className="hero-line">
        <motion.span
          initial={{ y: "110%" }}
          animate={{ y: "0%" }}
          transition={{ duration: 1, delay: 0.2 + i * 0.12, ease: [0.16, 1, 0.3, 1] }}
        >
          {ln}
        </motion.span>
      </span>
    ))}
  </h1>
);

export const PillButton = ({ children, onClick, variant, testid, type = "button" }) => (
  <button
    type={type}
    onClick={onClick}
    data-testid={testid}
    className={`cta ${variant === "ghost" ? "cta-ghost" : ""} ${variant === "light" ? "cta-light" : ""}`}
  >
    {children}
  </button>
);
